var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPikkocoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 45,
    viewBox: "0 0 42 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6189_13385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9979 44.7847C32.4783 44.7847 41.7849 35.1808 41.7849 23.3338C41.7849 11.4867 32.4783 1.88281 20.9979 1.88281C9.51759 1.88281 0.210938 11.4867 0.210938 23.3338C0.210938 35.1808 9.51759 44.7847 20.9979 44.7847Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.394006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9979 43.1187C32.4783 43.1187 41.7849 33.5148 41.7849 21.6678C41.7849 9.82072 32.4783 0.216797 20.9979 0.216797C9.51759 0.216797 0.210938 9.82072 0.210938 21.6678C0.210938 33.5148 9.51759 43.1187 20.9979 43.1187Z",
    fill: "url(#paint0_linear_6189_13385)",
    stroke: "#263238",
    strokeWidth: 0.394006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9979 43.1187C32.4783 43.1187 41.7849 33.5148 41.7849 21.6678C41.7849 9.82072 32.4783 0.216797 20.9979 0.216797C9.51759 0.216797 0.210938 9.82072 0.210938 21.6678C0.210938 33.5148 9.51759 43.1187 20.9979 43.1187Z",
    stroke: "#263238",
    strokeWidth: 0.394006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M38.6441 21.6647C38.6441 21.8301 38.6357 21.9911 38.6314 22.1565C23.4293 17.3988 10.9605 19.7886 3.38047 22.4917C3.36781 22.2175 3.35938 21.9432 3.35938 21.6647C3.35938 19.2706 3.8065 16.9853 4.62482 14.8916C7.22741 8.19251 13.5799 3.46094 21.0038 3.46094C28.4278 3.46094 34.5694 8.04016 37.2479 14.5651C38.1464 16.7459 38.6441 19.1443 38.6441 21.6647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2481 14.5651C23.4674 10.5953 12.0405 12.4583 4.625 14.8916C7.22759 8.19251 13.5801 3.46094 21.004 3.46094C28.428 3.46094 34.5696 8.04016 37.2481 14.5651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6206 24.7023H13.4137C13.2587 24.7023 13.1125 24.6304 13.0178 24.5077L12.6808 24.071C12.5533 23.9057 12.5419 23.6786 12.6522 23.5014L20.2994 11.2123C20.5651 10.7853 21.2239 10.9736 21.2239 11.4764V20.6984C21.2239 21.0152 21.5148 21.2521 21.825 21.1881L27.4468 20.0279C27.671 19.9816 27.898 20.0935 27.9978 20.2995L28.3717 21.0713C28.4447 21.2218 28.4375 21.3988 28.3527 21.5429L20.6348 34.6574C20.4591 34.956 20.0403 34.9897 19.8191 34.7231L19.3922 34.2087C19.3197 34.1213 19.279 34.0118 19.277 33.8983L19.1205 25.1933C19.1156 24.9207 18.8932 24.7023 18.6206 24.7023Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4213 23.3855L20.2917 10.0426C20.5503 9.60414 21.2223 9.78757 21.2223 10.2967V19.5505C21.2223 19.8266 21.4462 20.0505 21.7223 20.0505H27.6114C27.9984 20.0505 28.2387 20.4712 28.0421 20.8045L20.1718 34.1473C19.9131 34.5858 19.2411 34.4024 19.2411 33.8933V24.6395C19.2411 24.3633 19.0172 24.1395 18.7411 24.1395H12.852C12.465 24.1395 12.2247 23.7188 12.4213 23.3855Z",
    fill: "url(#paint1_linear_6189_13385)",
    stroke: "#353535",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6189_13385",
    x1: 0.210938,
    y1: 0.216797,
    x2: 75.2665,
    y2: 8.8135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6FF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6189_13385",
    x1: 11.9766,
    y1: 8.46484,
    x2: 42.0205,
    y2: 10.6156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6FF49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6189_13385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkocoin);
export default __webpack_public_path__ + "static/media/Pikkocoin.74b8bf84cc89daeaf3d7ec8f25e0ed79.svg";
export { ForwardRef as ReactComponent };